import api from './api';

const creditService = {
  // 取得額度資訊
  getCreditInfo: async () => {
    return await api.get('/agent/credit/info');
  },

  // 調整下級額度
  adjustCredit: async (data) => {
    return await api.post('/agent/credit/adjust', data);
  },

  // 給會員充值
  depositToMember: async (data) => {
    return await api.post('/agent/credit/deposit-to-member', data);
  },

  // 新增：從會員提領
  withdrawFromMember: async (data) => {
    return await api.post('/agent/credit/withdraw-from-member', data);
  },

  // 取得額度變更記錄
  getCreditRecords: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/credit/records?${queryString}`);
  }
};

export default creditService;